import script from "./OglobaVoucherStatusModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./OglobaVoucherStatusModal.vue?vue&type=script&lang=ts&setup=true"

import "./OglobaVoucherStatusModal.vue?vue&type=style&index=0&id=26aae578&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26aae578"]])

export default __exports__